// @flow

import * as types from '../actionTypes';
import {
  createActionBundleForMany,
  createActionBundleForSingle,
} from '../utils';
import type { offeringType } from '../../types';

export const getOfferingActions = createActionBundleForSingle(
  types.GET_OFFERING_ASYNC,
);
export const getOfferingListActions = createActionBundleForMany(
  types.GET_OFFERING_ASYNC,
);
export const miscOfferingActions = {
  prepopulateOfferings: (results: Array<offeringType>) => ({
    type: types.PREPOPULATE_OFFERINGS,
    results,
  }),
};
